import { API_BASE_DOMAIN, MARKITDOWN_API_URL } from './config';

// Markdown knowledge base is served by the ThinkPHP API controller.
const BASE_URL = `https://api.yjllq.com/api/Knowledge`;

export async function getKnowledgeInfo(ck) {
  const res = await fetch(`${BASE_URL}/getKnowledgeInfo?ck=${encodeURIComponent(ck)}`);
  return res.json();
}

export async function getKnowledgeList(kb_id, page = 1, size = 10, ck = '', folderId = 0) {
  const auth = ck ? `&ck=${encodeURIComponent(ck)}` : '';
  const folder = folderId ? `&folder_id=${encodeURIComponent(folderId)}` : '';
  const res = await fetch(`${BASE_URL}/getKnowledgeList?kb_id=${kb_id}&page=${page}&size=${size}${auth}${folder}`);
  return res.json();
}

export async function uploadKnowledge(ckOrKey, type, payload) {
  const formData = new FormData();
  // 如果是 key 模式，ckOrKey 就是 key；否则是 ck
  if (payload.isKeyUpload) {
    formData.append('key', ckOrKey);
  } else {
    formData.append('ck', ckOrKey);
  }
  formData.append('type', type);
  
  if (type === 1) { // web url
    formData.append('url', payload.url);
    if (payload.title) formData.append('title', payload.title);
    if (payload.content) formData.append('content', payload.content);
  } else if (type === 2) { // file
    formData.append('file', payload.file);
  } else if (type === 3) { // text
    formData.append('text', payload.text);
  }

  const res = await fetch(`${BASE_URL}/uploadKnowledge`, {
    method: 'POST',
    body: formData
  });
  return res.json();
}

export async function getDocumentParagraphs(ck, kb_id, doc_id, page = 1, size = 30) {
  const res = await fetch(`${BASE_URL}/getDocumentParagraphs?ck=${encodeURIComponent(ck)}&kb_id=${kb_id}&doc_id=${doc_id}&page=${page}&size=${size}`);
  return res.json();
}

export async function updateDocumentParagraph(ck, kb_id, doc_id, para_id, content, title = '') {
  const formData = new FormData();
  formData.append('ck', ck);
  formData.append('kb_id', kb_id);
  formData.append('doc_id', doc_id);
  formData.append('para_id', para_id);
  formData.append('content', content);
  formData.append('title', title);

  const res = await fetch(`${BASE_URL}/updateDocumentParagraph`, {
    method: 'POST',
    body: formData
  });
  return res.json();
}

export async function updateDocumentName(ck, kb_id, doc_id, name) {
  const formData = new FormData();
  formData.append('ck', ck);
  formData.append('kb_id', kb_id);
  formData.append('doc_id', doc_id);
  formData.append('name', name);

  const res = await fetch(`${BASE_URL}/updateDocumentName`, {
    method: 'POST',
    body: formData
  });
  return res.json();
}

export async function deleteDocument(ck, kb_id, doc_id) {
  const res = await fetch(`${BASE_URL}/deleteDocument?ck=${encodeURIComponent(ck)}&kb_id=${kb_id}&doc_id=${doc_id}`, {
    method: 'DELETE'
  });
  return res.json();
}

export async function hitTest(ck, queryText, knowledgeBaseAssociationEnabled = true, signal) {
  const formData = new FormData();
  formData.append('ck', ck);
  formData.append('query_text', queryText);
  formData.append('knowledge_base_association_enabled', knowledgeBaseAssociationEnabled ? '1' : '0');

  const res = await fetch(`${BASE_URL}/hitTest`, {
    method: 'POST',
    body: formData,
    signal
  });
  return res.json();
}

export async function exportKnowledgeBase(ck, kb_id) {
  const res = await fetch(`${BASE_URL}/exportKnowledgeBase?ck=${encodeURIComponent(ck)}&kb_id=${kb_id}`);
  return res.json();
}

async function fetchKnowledgeDownload(url) {
  const res = await fetch(url);
  const contentType = (res.headers.get('content-type') || '').toLowerCase();
  if (!res.ok || contentType.includes('application/json')) {
    let message = `下载失败（HTTP ${res.status}）`;
    try {
      const payload = await res.json();
      message = payload.message || payload.msg || message;
    } catch (error) {
      // Keep the HTTP error when the server did not return JSON.
    }
    throw new Error(message);
  }
  return res.blob();
}

export function downloadKnowledgeDocument(ck, id) {
  return fetchKnowledgeDownload(`${BASE_URL}/downloadDocument?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`);
}

export function downloadKnowledgeArchive(ck) {
  return fetchKnowledgeDownload(`${BASE_URL}/downloadArchive?ck=${encodeURIComponent(ck)}`);
}

export async function getUploadKey(ck) {
  const res = await fetch(`${BASE_URL}/getUploadKey?ck=${encodeURIComponent(ck)}`);
  return res.json();
}

export async function checkUploadKey(key) {
  const res = await fetch(`${BASE_URL}/checkUploadKey?key=${encodeURIComponent(key)}`);
  return res.json();
}

export async function getKnowledgeFolders(ck) {
  const res = await fetch(`${BASE_URL}/folders?ck=${encodeURIComponent(ck)}`);
  return res.json();
}

export async function createKnowledgeFolder(ck, name, parentId = 0) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('name', name);
  body.append('parent_id', parentId);
  const res = await fetch(`${BASE_URL}/createFolder`, { method: 'POST', body });
  return res.json();
}

export async function updateKnowledgeFolder(ck, id, payload = {}) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  Object.entries(payload).forEach(([key, value]) => body.append(key, value));
  const res = await fetch(`${BASE_URL}/updateFolder`, { method: 'POST', body });
  return res.json();
}

export async function deleteKnowledgeFolder(ck, id) {
  const res = await fetch(`${BASE_URL}/deleteFolder?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`, { method: 'DELETE' });
  return res.json();
}

export async function searchKnowledge(ck, query, size = 10) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('query', query);
  body.append('size', size);
  const res = await fetch(`${BASE_URL}/search`, { method: 'POST', body });
  return res.json();
}

export async function migrateKnowledge(ck, batch = 20) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('batch', batch);
  const res = await fetch(`${BASE_URL}/migrate`, { method: 'POST', body });
  return res.json();
}

export async function getKnowledgeWorkspace(ck) {
  const res = await fetch(`${BASE_URL}/workspaceBootstrap?ck=${encodeURIComponent(ck)}`);
  return res.json();
}

export async function getKnowledgeDocument(ck, id) {
  const res = await fetch(`${BASE_URL}/document?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`);
  return res.json();
}

export async function createKnowledgeDocument(ck, payload = {}) {
  const body = new FormData();
  body.append('ck', ck);
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) body.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
  });
  const res = await fetch(`${BASE_URL}/createDocument`, { method: 'POST', body });
  return res.json();
}

export async function updateKnowledgeDocument(ck, id, payload = {}) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) body.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
  });
  const res = await fetch(`${BASE_URL}/updateDocument`, { method: 'POST', body });
  return res.json();
}

export async function deleteKnowledgeDocument(ck, id) {
  const res = await fetch(`${BASE_URL}/deleteDocument?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`, { method: 'DELETE' });
  return res.json();
}

export async function moveKnowledgeDocument(ck, id, folderId, version = null) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  body.append('folder_id', folderId || 0);
  if (version !== null && version !== undefined) body.append('version', version);
  const res = await fetch(`${BASE_URL}/moveDocument`, { method: 'POST', body });
  return res.json();
}

export async function toggleKnowledgeFavorite(ck, id, favorite) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  body.append('favorite', favorite ? '1' : '0');
  const res = await fetch(`${BASE_URL}/favorite`, { method: 'POST', body });
  return res.json();
}

export async function getKnowledgeLinks(ck, id, direction = 'backlinks') {
  const res = await fetch(`${BASE_URL}/${direction}?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`);
  return res.json();
}

export async function getKnowledgeRevisions(ck, id) {
  const res = await fetch(`${BASE_URL}/revisions?ck=${encodeURIComponent(ck)}&id=${encodeURIComponent(id)}`);
  return res.json();
}

export async function restoreKnowledgeRevision(ck, id, version) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  body.append('version', version);
  const res = await fetch(`${BASE_URL}/restore`, { method: 'POST', body });
  return res.json();
}

export async function uploadKnowledgeAsset(ck, file) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('file', file);
  const res = await fetch(`${BASE_URL}/uploadAsset`, { method: 'POST', body });
  return res.json();
}

/** Convert a document to Markdown through the shared MarkItDown service. */
export async function convertKnowledgeFileToMarkdown(file) {
  if (!file) throw new Error('缺少待解析文件');
  const body = new FormData();
  body.append('file', file);
  let response;
  try {
    response = await fetch(MARKITDOWN_API_URL, {
      method: 'POST',
      body,
      redirect: 'follow'
    });
  } catch (error) {
    throw new Error(error && error.message ? `文档解析服务不可用：${error.message}` : '文档解析服务不可用');
  }

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    // Keep a useful HTTP error when the proxy/service did not return JSON.
  }
  if (!response.ok) {
    const message = payload && (payload.message || payload.error || payload.detail);
    throw new Error(message || `文档解析失败（HTTP ${response.status}）`);
  }
  const markdown = payload && typeof payload.markdown === 'string' ? payload.markdown.trim() : '';
  if (!markdown) {
    const message = payload && (payload.message || payload.error || payload.detail);
    throw new Error(message || '文档解析结果为空');
  }
  return { ...payload, markdown };
}

export async function resolveKnowledgeAssets(ck, references = []) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('references', JSON.stringify(Array.isArray(references) ? references : []));
  const res = await fetch(`${BASE_URL}/resolveAssets`, { method: 'POST', body });
  return res.json();
}

export async function deleteKnowledgeAsset(ck, id) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('id', id);
  const res = await fetch(`${BASE_URL}/deleteAsset`, { method: 'POST', body });
  return res.json();
}

export async function searchKnowledgeWorkspace(ck, query, filters = {}) {
  const body = new FormData();
  body.append('ck', ck);
  body.append('query', query);
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') body.append(key, Array.isArray(value) ? value.join(',') : value);
  });
  const res = await fetch(`${BASE_URL}/search`, { method: 'POST', body });
  return res.json();
}
